import { select, Selection } from "d3";

export abstract class BaseChartComponent {
    protected _currentContext: JQuery<HTMLElement> = null;
    protected chart: Selection<SVGSVGElement, unknown, HTMLElement, unknown> = null;
    protected chartType: string;

    public init(context: JQuery<HTMLElement>): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
    }

    private parseContext(): void {
        const intervalId = setInterval(() => {
            if (this._currentContext) {
                const elem = select(this._currentContext.get(0)).node();
                const isVisible = !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
                if (isVisible) {
                    try {
                        this.createChart();
                        this.renderChart();
                    } catch (e) {
                        console.error(e);
                    } finally {
                        clearInterval(intervalId);
                    }
                }
            }
        }, 100);
    }

    public createChart(): void {
        if (!this._currentContext) return;

        this._currentContext
            .attr("class", `${this._currentContext.attr("class")} pcg-${this.chartType}-chart pcg-contrast-${this.chartType}-chart`);

        const chartWrapper = select(this._currentContext.get(0))
            .append("div")
            .attr("class", "pcg-plot-wrap");

        this.chart = chartWrapper
            .append("svg")
            .attr("class", "pcg-plot")
            .attr("width", "100%")
            .attr("height", "100%");
    }

    public abstract renderChart(): void;
}
